import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const uploadTemplateApi = createAsyncThunk("uploadTemplate", async (formData) => {
    const response = await axiosInstance.post("/uploadTemplate", formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return response.data;
});

const uploadTemplateSlice = createSlice({
    name: "uploadTemplate",
    initialState: {
        uploadTemplate: [],
        errors: [],
        loading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(uploadTemplateApi.pending, (state) => {
                state.loading = true;
            })
            .addCase(uploadTemplateApi.fulfilled, (state, action) => {
                state.uploadTemplate = action.payload;
                state.loading = false;
            })
            .addCase(uploadTemplateApi.rejected, (state, action) => {
                state.errors = action.payload || action.error.message;
                state.loading = false;
            });
    },
});

export default uploadTemplateSlice.reducer;

